import Hero from "../components/home/Hero";
import Components from "../components/home/Components";
import AISection from "../components/home/AI";
import { useContext } from "react";
import { LanguageContext } from "../contexts/LanguageProvider";
import { ThemeContext } from "../contexts/ThemeProvider";
import BenefitsSection from "../components/home/Benefits";
import ContactForm from "../components/home/ContactForm";
import { useRef } from "react";
import SmartAppBanner from "../components/home/SmartBanner";
export default function Home() {
  const contactRef = useRef<HTMLDivElement | null>(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <SmartAppBanner
        appName="Omnia360"
        appIconUrl="/logo192.png"
        deepLinkUrl="omnia360://dashboard"
        iosAppStoreUrl="https://apps.apple.com/app/id6746214465"
        androidStoreUrl="https://play.google.com/store/apps/details?id=dev.expo.erpmobile"
        position="bottom"
        storageKey="__omnia360_smart_banner_dismissed"
        dismissForDays={30}
      />
      <Hero onContactClick={scrollToContact} />
      <Components />
      <AISection />
      <BenefitsSection />
      <div ref={contactRef}>
        <ContactForm />
      </div>
    </>
  );
}
